module.exports = __webpack_public_path__ + "static/media/50.26021e81.jpg";